import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../../components/sidebar';
import Loading from '../../components/loading/loading';
import { getPlaces } from '../../features/places/placesSlice';
import { useAppDispatch} from '../../app/hooks';
import MessageContainer from '../../components/messages';


const Layout = () => {
  // load all needed
  const dispatch = useAppDispatch();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const load_All = async() => {
      
      // load places
      await dispatch(getPlaces(true));
    }
    // load all
    load_All().then( ( ) => setLoaded(true) ).catch( ( err ) => { console.log(err); })
  }, [dispatch])
  
  if(!loaded) // manage loading page
    return <Loading />
  
  return (
    <div className="dashboard">
      <Sidebar />
      <div className="content container">
        <Outlet />
      </div>
      <MessageContainer />
    </div>
  )
}

export default Layout;